<div *ngIf="characterClass"
     class="class-icon"
     [class]="characterClass.name.toLowerCase() + '-icon'"
></div>
